import useSWR from 'swr';
import axios from 'axios';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useLocations = (regionId) => {
  const urlStr = `${getApiUrl()}/location?regionId=${regionId}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePostLocation = () => {
  const postLocation = async (payload) => {
    try {
      const url = `${getApiUrl()}/mega/location`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postLocation;
};

export const usePutLocation = () => {
  const putLocation = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/mega/location/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putLocation;
};

export const useDeleteLocation = () => {
  const deleteRegion = async (id) => {
    try {
      const url = `${getApiUrl()}/mega/location/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return deleteRegion;
};
